import React from 'react'
import './Homes.scss'
import image from '../../img/sprite.svg'

import house1 from '../../img/house-1.jpeg'
import house2 from '../../img/house-2.jpeg'
import house3 from '../../img/house-3.jpeg'
import house4 from '../../img/house-4.jpeg'
import house5 from '../../img/house-5.jpeg'
import house6 from '../../img/house-6.jpeg'
export const Homes = () => {
    return (
        <section className="homes">
            <div className="home">
                <img src={house1} alt="House 1" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Vackert familjehem</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Lidingö</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>5 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>325 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€1.000,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>

            <div className="home">
                <img src={house2} alt="House 2" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Modern Glas Villa</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Danderyd</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>6 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>425 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€2.125,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>

            <div className="home">
                <img src={house3} alt="House 3" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Mysig Villa i lungt landskap</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Dalarö</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>4 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>225 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€690,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>

            <div className="home">
                <img src={house4} alt="House 4" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Stor Rustik Villa</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Portugal</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>6 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>475 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€2.100,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>

            <div className="home">
                <img src={house5} alt="House 5" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Majestätisk Palats Villa</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Frankrike</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>16 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>4175 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€9.100,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>
            
            <div className="home">
                <img src={house6} alt="House 6" className="home__img"></img>
                <svg className="home__like">
                    <use xlinkHref={` ${image}#icon-heart-full`}> </use>
                </svg>
                <h5 className="home__name">Modern lägenhet</h5>

                <div className="home__location">
                <svg>
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <p>Italien</p>
                </div>

                <div className="home__rooms">
                <svg>
                    <use xlinkHref={` ${image}#icon-profile-male`}> </use>
                </svg>
                <p>3 rum</p>
                </div>

                <div className="home__area">
                <svg>
                    <use xlinkHref={` ${image}#icon-expand`}> </use>
                </svg>
                <p>145 m<sup>2</sup></p>
                </div>

                <div className="home__price">
                <svg>
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <p>€1.100,000</p>
                </div>
                <button className="btn home__btn">Kontakta mäklare</button>
            </div>
        </section>
    )
}
